export default __webpack_public_path__ + "static/building_pin-selected.f66d4f4a96f35e6cf3be91ce67833b04.svg";